import { setSessionStorage, getSessionStorage } from '@/utils/stage';
import { getconfig } from '../api/init';
import Vue from 'vue';
let langType = '';
let type = 'pro';
let lang = 'cn';
let xmtlang = 'en-us';
console.log(
	'navigator.language.toLowerCase()',
	navigator.language.toLowerCase()
);
if (
	window.location.href.indexOf('payment.catfantasygame.com') > -1 ||
	window.location.href.indexOf('gray-paymenten.catfantasygame.com') > -1
) {
	langType = 'en';
	lang = 'en';
	document.title = 'catfantasy-payment';
} else if (
	window.location.href.indexOf('paymentkr.catfantasygame.com') > -1 ||
	window.location.href.indexOf('gray-paymentkr.catfantasygame.com') > -1
) {
	langType = 'kr';
	lang = 'kr';
	document.title = '캣 판타지-상점';
} else if (
	window.location.href.indexOf('paymenttw.catfantasygame.com') > -1 ||
	window.location.href.indexOf('gray-paymenttw.catfantasygame.com') > -1
) {
	langType = 'tw';
	lang = 'tw';
	document.title = '貓之城-儲值中心';
} else if (
	window.location.href.indexOf('paymentjp.catfantasygame.com') > -1 ||
	window.location.href.indexOf('gray-paymentjp.catfantasygame.com') > -1
) {
	langType = 'jp';
	lang = 'jp';
	document.title = 'チャージセンター『キャットファンタジ―』';
	// catfantasyshop.bonfiregathering.com
} else if (
	window.location.href.indexOf('catfantasyshop.bonfiregathering.com') > -1
) {
	const lang1 = navigator.language.toLowerCase();
	document.title =
		'Cat Fantasy SEA: Official Top-Up Site – Get 18% Bonus Now!';
	langType = 'xmt';
	if (lang1 == 'th-th') {
		xmtlang = 'th-th';
		lang = 'th';
	} else {
		lang = 'en';
		xmtlang = 'en-us';
	}
}

if (
	window.location.href.indexOf('passport-web-pay.17atv.com') > -1 ||
	process.env.NODE_ENV === 'development' ||
	window.location.href.indexOf('7070') > -1
) {
	// langType = 'xmt';
	// type = 'test';
	// langType = 'xmt';
	// lang = 'kr';
	// const lang1 = navigator.language.toLowerCase();
	document.title = '貓之城-儲值中心';
	langType = 'xmt';
	// if (lang1 == 'zh-cn') {
	// 	lang = 'en';
	// 	xmtlang = 'en-us';
	// } else if (lang1 == 'th-th') {
	// 	lang = 'th';
	// 	xmtlang = 'th-th';
	// } else {
	// 	lang = 'en';
	// 	xmtlang = 'en-us';
	// }
	type = 'pro';
	//     const lang1 = navigator.language.toLowerCase()
	//     langType ='xmt'
	//     if(lang1=='zh-cn'){
	//     lang = 'cn'
	//     }else if(lang1=='th-th'){
	//     lang = 'th'
	//    }else {
	//     lang ='en'
	//    }
	//    type = 'pro';
}
sessionStorage.setItem('lang', lang);
const cdnUrl = {
	tw: `https://cat-tw-img-cy.fungoglobal.com`,
	kr: `https://cat-kr-img-cy.fungoglobal.com`,
	jp: `https://cat-jp-img-cy.fungoglobal.com`,
	xmt: `https://cdn-cf.bfg.in.th`,
	en: `https://cat-jp-img-cy.fungoglobal.com`,
};
// 正式服 项目ID tw46  新马47  kr50
// 测试服 项目ID tw45  新马47  kr51 53jp
const appidList = {
	tw: {
		name: '貓之城',
		lang: 'zh-tw',
		pro: {
			projectId: 46,
			app_id: '949792f00e554719ef2ee6f6deef0cc5',
			client_game_app_id: '2972947d72960283a623e9cea1aae4da',
		},
		test: {
			projectId: 45,
			app_id: '3b0c348056a155bdbf415939a2c2de2c',
			client_game_app_id: 'b2b2d5a215af171cc8935b1d237e0635',
			// projectId: 46,
			// app_id: '949792f00e554719ef2ee6f6deef0cc5',
			// client_game_app_id: '2972947d72960283a623e9cea1aae4da',
		},
	},
	kr: {
		name: '캣 판타지',
		lang: 'ko-kr',
		pro: {
			projectId: 50,
			app_id: '87c98d10d15a9a460110578ef1061885',
			client_game_app_id: '1dbf54744e6c8d5f717bfa060605e01f',
			// client_game_app_id: 'ceb782c283b0b70c43544a70783d641d',
		},
		test: {
			projectId: 51,
			app_id: 'd82b2af6056f68976d0bd9c9cf6aea2f',
			client_game_app_id: '81d4b4bef73ee1214568d92ccaa6de91',
		},
	},
	en: {
		name: 'catfantasy',
		lang: 'en-us',
		pro: {
			projectId: 45,
			app_id: '27baeca333b1131c32da979cd86dab2c',
			client_game_app_id: 'ecc60841370368a7555a9c2edda45f8f',
		},
		test: {
			name: 'catfantasy',
			projectId: 47,
			app_id: 'aeb578a446b244718c8786ee02905a57',
			client_game_app_id: 'ae5b63c7f24723428c7ac18f509414d6',
		},
	},
	cn: {
		name: '猫之城',
		lang: 'zh-cn',
		pro: {
			projectId: 48,
			app_id: '26a4a635c36dce7a77f945555fc27e70',
			client_game_app_id: '5530bc17df43b8e1627a5528baab520c',
		},
		test: {
			projectId: 52,
			app_id: 'a24e744d9144c6104dcbd05abe79ac92',
			client_game_app_id: '14501f45019b5556cfafbf66cb92b374',
		},
	},
	jp: {
		name: 'キャットファンタジー',
		lang: 'ja-jp',
		pro: {
			projectId: 51,
			app_id: '93916b6ee1a3b1dd667f05d00eeb995c',
			client_game_app_id: 'dec9e0ea06cc75db797fe5f55db45199',
		},
		test: {
			projectId: 53,
			app_id: '44a9e65a3f2a847f818b59919b456950',
			// client_game_app_id: "db1552e5a663b0c3a3cac43a02d52ce7",
			client_game_app_id: '08bb53cf270583652370979572b274b6',
			// projectId: 51,
			// app_id: "93916b6ee1a3b1dd667f05d00eeb995c",
			// client_game_app_id: "dec9e0ea06cc75db797fe5f55db45199",
		},
	},
	xmt: {
		name: 'Catfantasy',
		lang: xmtlang,
		pro: {
			projectId: 54,
			app_id: '6c7493ef2e6e974ac90ec891465e24ce',
			client_game_app_id: '17a8af8e5409099b3290924aeb3d2396',
		},
		test: {
			projectId: 54,
			app_id: '6c7493ef2e6e974ac90ec891465e24ce',
			client_game_app_id: '17a8af8e5409099b3290924aeb3d2396',
		},
	},
};
const proInfo = {
	app_id: appidList[langType][type].app_id,
	projectId: appidList[langType][type].projectId,
	client_game_app_id: appidList[langType][type].client_game_app_id,
	gameName: appidList[langType].name,
	lang: appidList[langType].lang,
};

// function setConfig() {
// 	console.log('proInfo', proInfo);
// 	window.sessionStorage.setItem('proInfo', JSON.stringify(proInfo));
// 	console.log(123);
// 	window.sessionStorage.setItem('initConfig', JSON.stringify(proInfo));
// 	console.log(456);
// }
Vue.prototype.$initConfig = JSON.stringify(proInfo);
Vue.prototype.$cdn = cdnUrl[langType];
Vue.prototype.$langType = langType;
function setConfig() {
	window.sessionStorage.setItem('proInfo', JSON.stringify(proInfo));
	window.sessionStorage.setItem('initConfig', JSON.stringify(proInfo));
	setTimeout(() => {
		// console.log(123333, getSessionStorage('initConfig'));
		if (!getSessionStorage('initConfig')) {
			setConfig();
		}
	}, 500);
}
// document.addEventListener('DOMContentLoaded', function() {

const msg = {
	platform: 'web',
	kid: '123456',
	sdk_code: 3,
	app_id: proInfo.app_id,
	client_game_app_id: proInfo.client_game_app_id,
};
setConfig();
getconfig(msg).then((res) => {
	const obj = res.data;
	if (res.data.pay_ways.length > 0) {
		if (langType !== 'xmt') {
			setSessionStorage('paywayid', res.data.pay_ways[0].type);
			setSessionStorage('config', JSON.stringify(res.data));
			return obj;
		}
		const configInit = filterPayWays(res.data);
		console.log('filterPayWays', configInit);
		setSessionStorage('paywayid', configInit.pay_ways[0].type);
		setSessionStorage('config', JSON.stringify(configInit));
		// 调用函数
		// console.log(getPaymentMethod(666789, obj));
	}
});
function filterPayWays(obj) {
	const { country_code, pay_ways } = obj;
	const hasType37 = pay_ways.some((item) => item.type === '37');
	const hasType40 = pay_ways.some((item) => item.type === '40');

	// 只有同时存在 37 和 40 时才处理
	if (hasType37 && hasType40) {
		if (['SG', 'MY', 'PH', 'ID'].includes(country_code)) {
			obj.pay_ways = pay_ways
				.map(
					(item) => (item.type === '37' ? null : { ...item }) // 仅删除 type=37
				)
				.filter(Boolean);

			// 处理图片路径
			const imgMap = {
				SG: 'coda_sg.jpg',
				MY: 'coda_my.jpg',
				PH: 'coda_ph.jpg',
				ID: 'coda_id.jpg',
			};
			const changeImgSrc = imgMap[country_code] || 'codepay.png';
			obj.pay_ways.forEach((item) => {
				if (item.type === '40') {
					item.changeImgSrc = changeImgSrc;
				}
			});
		} else {
			obj.pay_ways = pay_ways
				.map(
					(item) => (item.type === '40' ? null : { ...item }) // 仅删除 type=40
				)
				.filter(Boolean);
			const changeImgSrc = 'xendit1.jpg';
			obj.pay_ways.forEach((item) => {
				if (item.type === '37') {
					item.changeImgSrc = changeImgSrc;
				}
			});
		}
	}

	return obj;
}
